import { useState } from "react";
import { useData } from "@/hooks/useData";
import { Material } from "@/types/material/material.types";
import { useMaterialFilters } from "@/hooks/materials/useMaterialFilters";

export const useMaterialTable = () => {
    const [searchTerm, setSearchTerm] = useState("");
    const [nameFilters, setNameFilters] = useState<string[]>([]);

    const {
        data: materials,
        loading,
        refetch,
    } = useData<Material>({
        collectionName: "setup_materials",
    });

    const { filteredMaterials, getUniqueOptions } = useMaterialFilters({
        materials,
        searchTerm,
        nameFilters,
    });

    const clearFilters = () => {
        setSearchTerm("");
        setNameFilters([]);
    };

    const nameOptions = getUniqueOptions("name");

    return {
        materials,
        filteredMaterials,
        loading,
        refetch,
        searchTerm,
        setSearchTerm,
        nameFilters,
        setNameFilters,
        clearFilters,
        nameOptions,
    };
}; 